import React from 'react';
import {DatePicker, Form, Input, InputNumber, message, Modal} from 'antd';
import moment from "moment";

class FieldEdit extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      contractId: '',
      assetRecordId: '',
      amountId: '',
      suspenseId: '',
      docId: '',
      label: '',
      fieldName: '',
      fieldValue: null,
      editType: 'text',
    };
  }

  onCancel = () => {
    this.props.showToggle(this.props.data._id);
  }

  componentDidMount() {
    const {field, label, value, contract, asset, type} = this.props.fileObj;
    this.setState({
      contractId: contract,
      assetRecordId: asset,
      label: label,
      fieldName: field,
      fieldValue: value,
      editType: type || 'text',
    });
  }

  onChange = (value, name) => {
    // console.log(moment(value).format('YYYY-MM-DD'))
    const {editType} = this.state;
    // data['value'] = value;
    // data['field'] = name;
    this.setState({
      fieldName: name,
      fieldValue: editType === 'date' ? moment(value).format('YYYY-MM-DD') : value,
    });
    // console.log(this.state.dataObj)
  };

  validate = () => {
    const {fieldName, fieldValue, contractId, label} = this.state;
    if(contractId && fieldName && fieldValue) {
      message.error('Invalid Value for ' + label);
      return false;
    }
    return true;
  }

  onCreate = () => {
    const {fieldName, fieldValue, contractId, assetRecordId, label} = this.state;
    if(contractId && fieldName && fieldValue) {
      this.props.updateContract(contractId, assetRecordId, {field: fieldName, value: fieldValue, contract: contractId});
      this.onCancel();
    }
  }

  disabledDate = (current) => {
    const {data} = this.props;
    const assetData = data.assets.filter(doc => doc._id === this.props.assetRecord);
    if(assetData && assetData[0]) {
      const fromDate = assetData[0].periodFrom;
      const toDate = assetData[0].periodTo;
      return current && !moment(current).isBetween(moment(fromDate).startOf('day'), moment(toDate).endOf('day'));
    }
  }

  renderField = () => {
    const {
      label,
      editType,
      fieldName,
      fieldValue
    } = this.state;
    let field = null;
    switch (editType) {
      case 'text':
        field = (<Form.Item key={fieldName} label={label} style={{width: '100%'}}>
          <Input defaultValue={fieldValue} onChange={(e) => this.onChange(e, fieldName)}/>
        </Form.Item>);
        break;

      case 'numeric':
        field = (<Form.Item key={fieldName} label={label} style={{width: '100%'}}>
          <InputNumber defaultValue={fieldValue} onChange={(e) => this.onChange(e, fieldName)}/>
        </Form.Item>);
        break;

      case 'date':
        field = (<Form.Item key={fieldName} label={label} style={{width: '100%'}}>
          <DatePicker defaultValue={moment(fieldValue)} onChange={(e) => this.onChange(e, fieldName)}/>
        </Form.Item>);
        break;

      default:
        field = (<Form.Item key={fieldName} label={label} style={{width: '100%'}}>
          <Input defaultValue={fieldValue} onChange={(e) => this.onChange(e, fieldName)}/>
        </Form.Item>);
        break;
    }
    return field;
  }

  render() {
    const {visible} = this.props;
    return (
      <div>
        <Modal
          visible={visible}
          title={'Edit ' + this.state.label}
          okText="Save"
          onCancel={this.onCancel}
          onOk={this.onCreate}
        >
          <Form layout="vertical">
            {this.renderField()}
          </Form>
        </Modal>
      </div>
    );
  }
}

export default FieldEdit;
